export enum Role {
  SuperAdmin = 1,
  Admin = 2,
  User = 3,
  Public = 4,
  Api = 5,
}

const ROLE_LABELS: Record<number, string> = {
  [Role.SuperAdmin]: 'Super Admin',
  [Role.Admin]: 'Admin',
  [Role.User]: 'Usuario',
  [Role.Public]: 'Invitado',
  [Role.Api]: 'API',
};

// Tipos que se pueden elegir al crear o editar un usuario
export const ASSIGNABLE_ROLES = [Role.SuperAdmin, Role.Admin, Role.User, Role.Api];

export function getRoleLabel(role: number): string {
  return ROLE_LABELS[role] ?? 'Usuario';
}

export function isAdminRole(role: number): boolean {
  return role === Role.SuperAdmin || role === Role.Admin;
}
